import { useState, useEffect } from 'react';

const useLoadingTimer = isLoading => {
  const [loadingTime, setLoadingTime] = useState(0);

  useEffect(() => {
    let intervalId;

    setLoadingTime(0);
    if (isLoading) {
      intervalId = setInterval(() => {
        setLoadingTime(prevTime => prevTime + 1);
      }, 1000);
    }

    if (intervalId && isLoading === false) {
      clearInterval(intervalId);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [isLoading]);

  return loadingTime;
};

export default useLoadingTimer;
